import { Extension } from '@tiptap/core';
import { activateMediaManager } from 'Shared/FrameModules/MediaLibrary/media_manager_helpers';

declare module '@tiptap/core' {
   interface Commands<ReturnType> {
      mediaManager: {
         activateMediaManager: () => ReturnType;
      };
   }
}

export const MediaManager = Extension.create({
   name: 'mediaManager',

   addCommands() {
      return {
         activateMediaManager:
            () =>
            ({ commands }) => {
               commands.blur();
               const editor = this.editor;

               // eslint-disable-next-line @typescript-eslint/no-floating-promises -- FIXME: Promises must be awaited, end with...
               activateMediaManager('wiki_media').then(mediaItem => {
                  const imageContent = mediaItem.toWikiText();
                  editor.chain().focus().insertContent(imageContent).run();
               });
               return true;
            },
      };
   },
});
